import { CSSProperties } from 'react'

export const HeaderIconPathStyles: CSSProperties = {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
}

export const HeaderIconSVGStyles = {
  active: 'fill-[#0E72ED]',
  nonActive: 'fill-[#6E7680]',
  hover: 'fill-black',
}
